module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst toggleModel = {...model}\ntoggleModel.atom.dataType = 'boolean'\n%><div>\n<div class=\"toggleContainer\">\n<%- include('../../../../base/form/fields/toggle', { model: toggleModel, config }); %>\n<%- include('../../../../base/form/elements/label', { formMapping, model }); %>\n</div>\n<div class=\"buttonContainer\">\n<%- include('../../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'navToList', context: model.config.buttonContext, mode: model.config.buttonMode, symbolOnly: true } }); %>\n</div>\n</div>"
  , __filename = "components/templates/core/form/fields/toggleAndLink.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const toggleModel = {...model}
toggleModel.atom.dataType = 'boolean'

    ; __line = 4
    ; __append("<div>\n<div class=\"toggleContainer\">\n")
    ; __line = 6
    ; __append( include('../../../../base/form/fields/toggle', { model: toggleModel, config }) )
    ; __append("\n")
    ; __line = 7
    ; __append( include('../../../../base/form/elements/label', { formMapping, model }) )
    ; __append("\n</div>\n<div class=\"buttonContainer\">\n")
    ; __line = 10
    ; __append( include('../../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'navToList', context: model.config.buttonContext, mode: model.config.buttonMode, symbolOnly: true } }) )
    ; __append("\n</div>\n</div>")
    ; __line = 12
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/core/form/fields/toggleAndLink.ejs

}